import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/app-store.png'
import _imports_1 from '@/assets/google-play.png'
import _imports_2 from '@/assets/apps-icon_home.png'


const _withScopeId = n => (_pushScopeId("data-v-c17bc5f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "apps" }
const _hoisted_2 = { class: "apps__info" }
const _hoisted_3 = { class: "apps__title" }
const _hoisted_4 = { class: "apps__sub" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"apps__btns\" data-v-c17bc5f6><a class=\"apps__app\" href=\"https://apps.apple.com/us/app/lily-plant-identification/id1570145257\" target=\"_blank\" rel=\"noopener\" data-v-c17bc5f6><img src=\"" + _imports_0 + "\" width=\"109\" height=\"38\" alt=\"app store\" data-v-c17bc5f6></a><a class=\"apps__app\" href=\"https://play.google.com/store/apps/details?id=com.laraun.plantapp&amp;hl=uk&amp;gl=US\" target=\"_blank\" rel=\"noopener\" data-v-c17bc5f6><img src=\"" + _imports_1 + "\" width=\"109\" height=\"38\" alt=\"google play\" data-v-c17bc5f6></a></div>", 1)
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "apps__icon",
  alt: "apps-icon"
}, null, -1))

import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Apps',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('page_home_apps_section_title')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('page_home_apps_section_subtitle')), 1),
      _hoisted_5
    ]),
    _hoisted_6
  ]))
}
}

})